import { configureStore } from "@reduxjs/toolkit"
import { combineReducers, applyMiddleware} from "redux"
import { Login, Sign_up, UserInfo,  generate_cv, cv_id, cv_pics, existing_cv, get_me_my_cv, get_my_profile,verify_mail, password_reset, activities, skills, jobTitle, Professional_summary, education, p_skills, voluntary, award, reference, language, individual_experience, translate_lang, persomal_information, cert, lang, spanish, resumeStepChange, get_employer_profile, employer_about, langType, last_resume, secret, get_public_profile, save_link } from "./Reducers"
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { logger } from "redux-logger";


const persistConfig = {
  key: 'root',
  storage,
  // blacklist: ["saved_cv"]
}

const rootReducer = combineReducers({
  login: Login,
  signup: Sign_up,
  userInfo: UserInfo,
  profile: get_my_profile,
  verify_mail: verify_mail,
  password_reset: password_reset,
  saved_cv: get_me_my_cv,
  generateCV: generate_cv,
  existingCV: existing_cv,
  cvId: cv_id,
  cvpics: cv_pics,
  activities: activities,
  skills: skills,
  jobTitle: jobTitle,
  summary: Professional_summary,
  education: education,
  p_skills: p_skills,
  voluntary: voluntary,
  award: award,
  reference: reference,
  language: language,
  exp: individual_experience,
  t_lang: translate_lang,
  personal_info: persomal_information,
  cert: cert,
  lang: lang,
  resumeStep: resumeStepChange,
  spanish: spanish,
  employer: get_employer_profile,
  about: employer_about,
  type: langType,
  last_resume: last_resume,
  secret: secret,
  public: get_public_profile,
  userLink: save_link
})

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk, logger]
})

export const persistor = persistStore(store);
